import React, { useCallback, useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import { orderBy } from 'lodash'
import LetterPaperLayoutListItem from './letter-paper-layout-list-item'

const useStyles = makeStyles((theme) => ({
  list: {
    'li': {
      borderBottom: theme.border,
      '& .default-badge': {
        display: 'inline',
        opacity: 0,
      },
      '&:hover': {
        '.default-badge': {
          opacity: 1,
        },
      },
    },
  },
}))

function LetterPaperLayoutList(props) {
  const classes = useStyles()
  const { data, defaultId, onSelect, onSetDefault, selectedItemId, setSelectedItemId, isOnboardingTester = false } = props

  const onSelectInternal = useCallback((id) => {
    setSelectedItemId(id)
    onSelect && onSelect(id)
  }, [onSelect])

  useEffect(() => {
    if (selectedItemId === null) {
      setSelectedItemId(data[0].id)
    }
  }, [data])

  const items = orderBy(data).map(item => (<LetterPaperLayoutListItem
    key={item.id}
    onSelect={onSelectInternal}
    isDefault={defaultId === item.id}
    selected={item.id === selectedItemId}
    onSetDefault={onSetDefault} {...item}
    isOnboardingTester={isOnboardingTester}
  />))

  return (
    <>
      <ul className={classes.list}>{items}</ul>
    </>
  )
}

LetterPaperLayoutList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  defaultId: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  onSetDefault: PropTypes.func.isRequired,
  selectedItemId: PropTypes.string.isRequired,
  setSelectedItemId: PropTypes.string.isRequired,
}

export default LetterPaperLayoutList
